import { render, staticRenderFns } from "./SettingsUsersView.vue?vue&type=template&id=58287a32"
import script from "./SettingsUsersView.vue?vue&type=script&lang=ts"
export * from "./SettingsUsersView.vue?vue&type=script&lang=ts"
import style0 from "./SettingsUsersView.vue?vue&type=style&index=0&id=58287a32&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports